import { createRoot } from "react-dom/client";
import { updateHeaderButtons } from "@/components/auth/social-auth";
import { addTranslation } from "@/utils/i18n";
import type { Auth } from "./types";

interface CreateAuthDialogProps {
  view: Auth.View;
  onSuccess?: (response: Auth.Response) => void;
}

export const createAuthDialog = async (props: CreateAuthDialogProps) => {
  const config = window.authConfig;

  if (config !== undefined) {
    addTranslation(config.translation);

    const container = document.createElement("div");

    document.body.appendChild(container);

    const root = createRoot(container);

    const { AuthDialog } = await import("./components/auth-dialog/AuthDialog");

    const onSuccess = (response: Auth.Response) => {
      props.onSuccess?.(response);
      updateHeaderButtons(config.api.getHeaderButtons);
    };

    root.render(
      <AuthDialog
        view={props.view}
        config={config}
        onSuccess={onSuccess}
        onClose={() => {
          root.unmount();
          container.remove();
        }}
      />,
    );
  }
};
